import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import dayjs from 'dayjs';

import config from '../../config';
import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { GridCard } from '../helpers/GridCard';
import { MailingHistoryTable } from './MailingHistoryTable';

import style from './style.module.css';

const columnDefs = config.mailingHistory.getIn(['table', 'columnDefs']);

/**
 * Mailing history page component.
 *
 * @param props {Object}.
 * @param props.user {Immutable.Map} Current user.
 * @param props.mailingHistory {Immutable.Map} Mailing history table data.
 * @param props.onReload {Function} Reload the table.
 */
const MailingHistoryComponent = ({ user, mailingHistory, onGetNextPageData, onChange, onDoubleClickRow, onReload }) => {
  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onReload}>
        <i aria-hidden="true" className="fa fa-refresh" /> Reload
      </Button>
    </div>
  );

  return (
    <AppPage
      overline={`${user.get('userName')} · ${dayjs().format('MM/DD/YYYY')}`}
      title="Mailing History"
      toolbar={toolbar}
    >
      <GridCard className={style.grid} dense>
        <MailingHistoryTable
          columnDefs={columnDefs}
          data={mailingHistory}
          onChange={onChange}
          onDoubleClickRow={onDoubleClickRow}
          onGetNextPageData={onGetNextPageData}
        />
      </GridCard>
    </AppPage>
  );
};

MailingHistoryComponent.propTypes = {
  mailingHistory: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onDoubleClickRow: PropTypes.func.isRequired,
  onGetNextPageData: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
  user: PropTypes.instanceOf(Map).isRequired,
};

export const MailingHistory = memo(MailingHistoryComponent);
